// eslint-disable-next-line @vio/custom-rules/prefer-usebrand-hook
import {getBrand} from '@vio/core/src/_web/brand/modules/selectors'
import {getSearchHost} from '@vio/core/src/brand/utils'
import {buildUrl} from '@vio/core/src/utils/url'

// eslint-disable-next-line no-restricted-imports
import {
  navigateToBooking,
  navigateToHotelSearch,
  navigateToPaymentPage,
  navigateToSearch
} from '../../modules/bookingManagement/bookingNavigation'
import {
  BOOKING_MANAGEMENT_PATH,
  getPaymentPageUrl,
  getSearchResultsUrl
} from '../../utils/bookingManagement/urls'
import {MiddlewareType} from '../middlewareList'
import {REDIRECT_EXTERNAL} from './actions/externalRedirect'

const middleware: MiddlewareType = store => next => action => {
  switch (action.type) {
    case REDIRECT_EXTERNAL: {
      window.location.replace(action.url)
      break
    }

    // Booking management navigation actions
    case navigateToSearch.type: {
      const brand = getBrand(store.getState())
      const searchHost = getSearchHost({
        brand,
        appEnv: process.env.NEXT_PUBLIC_ENV
      })

      if (searchHost) {
        window.location.href = searchHost
      }

      break
    }

    case navigateToHotelSearch.type: {
      const brand = getBrand(store.getState())
      const url = buildUrl(getSearchResultsUrl(brand), action.payload)
      const {isSamePage} = action.payload
      window.open(url, isSamePage ? '_self' : '_blank')

      break
    }

    case navigateToPaymentPage.type: {
      const brand = getBrand(store.getState())
      const url = buildUrl(getPaymentPageUrl(brand), action.payload)
      const {isSamePage} = action.payload
      window.open(url, isSamePage ? '_self' : '_blank')

      break
    }

    case navigateToBooking.type: {
      const {bookingId, isMobile, ...rest} = action.payload
      const url = buildUrl(`${BOOKING_MANAGEMENT_PATH}/${bookingId}`, rest)

      if (!isMobile) {
        window.open(url, '_blank')
      } else {
        window.location.href = url
      }

      break
    }

    default: {
      break
    }
  }

  return next(action)
}

export default middleware
